import { Environment } from '../contentstackEnvironment';
import { ContentstackRegion } from '../contentstackRegion';
import type { ContentWithStatus } from '../types';
import { fetchContentGraphQLWithCaching } from './fetchContentGraphQLWithCaching';
import { fetchContentGraphQLWithoutCaching } from './fetchContentGraphQLWithoutCaching';
import type { FetchContentGraphQlArgs, FetchContentGraphQlOptions } from './types';

const DEFAULT_TIMEOUT = 1000;
const DEFAULT_CACHE_TTL = 300;

export const fetchContentGraphQL = async (
  { deliveryToken, environment, query, stackAPIKey, variables }: FetchContentGraphQlArgs,
  {
    branch,
    cacheKey,
    cacheTTLInSeconds = DEFAULT_CACHE_TTL,
    region = ContentstackRegion.NORTH_AMERICA,
    timeout = DEFAULT_TIMEOUT,
  }: FetchContentGraphQlOptions = {},
): Promise<ContentWithStatus> => {
  if (cacheKey && environment !== Environment.Preview) {
    const branchSafeCacheKey = branch ? `${cacheKey}-${branch}` : cacheKey;

    return fetchContentGraphQLWithCaching(
      { deliveryToken, environment, query, stackAPIKey, variables },
      { branch, cacheKey: branchSafeCacheKey, cacheTTLInSeconds, region, timeout },
    );
  }

  return fetchContentGraphQLWithoutCaching(
    { deliveryToken, environment, query, stackAPIKey, variables },
    { branch, region, timeout },
  )
    .then((body) => {
      return {
        content: body,
        status: 'fresh' as const,
      };
    })
    .catch((error) => {
      return {
        content: error.message || error,
        status: 'error' as const,
      };
    });
};
